import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../../auth';
import { Globals } from '../../globals';
import { Cookie } from 'ng2-cookies';
import { Observable } from 'rxjs';

@Injectable()
export class SecurityAgreementFormService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }

    saveFas(fas) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/securityAgreement';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('fasBody', JSON.stringify(fas));

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Update existing project
     * @param project project object
     */
    updateFas(fas) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/securityAgreement/' + fas.id;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('fasBody', JSON.stringify(fas));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
    * Method to fetch a security agreement from the server
    * @param fasId unique identifier for security agreement
    */
    getSecurityAgreementById(fasId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/securityAgreement/' + fasId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Fetch an employer based on organisation ID.
     * @param orgId Organisation ID.
     * @param countryCode country code for organisation
     */
    getEmployerByOrgId(orgId, countryCode): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/byOrgId/' + orgId + '/' + countryCode;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Fetch all employers.
     */
    getAllEmployers(): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        
        return this.http.get(url, { headers: requestHeaders, responseType: 'json' });
    }

}
